import React from "react";
import { makeRootController } from "../controllers/_root.controller";

export const RootControllerInstance = makeRootController();

export const RootContext = React.createContext(RootControllerInstance);
